/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of Zuum Transportation Inc.
 #*
 #* Copyright Zuum 2015-2021. All Rights Reserved.
 #*
 #*===================================================================
 */

import { createReducer, on } from '@ngrx/store';

import { Plan } from '@core/models';
import { PlanActions } from '@store/actions';

export const PLAN_FEATURE_KEY = 'plan';

export interface PlanState {
  plans: Plan[];
  isLoading: boolean;
}

const initialState: PlanState = {
  plans: null,
  isLoading: false,
} as any;

export const planReducer = createReducer(
  initialState,
  on(PlanActions.loadPlans, (state) => ({
    ...state,
    isLoading: true,
  })),

  on(PlanActions.loadPlansSuccess, (state, { plans }) => ({
    ...state,
    plans,
    isLoading: true,
  }))
);
